import { Modal } from "antd";
import { DeviceProductionAddbyCount } from "./DeviceProductionItemAddbyCount";
import { DeviceProductionAddbyList } from "./DeviceProductionItemAddbyList";

const DeviceProductionModal = ({
  isOpenModal,
  title,
  setIsOpenModal,
  productionRefetch,
  modalType,
  productionId,
  itemId,
  LicenseNo,
}) => {
  return (
    <div className="container-fluid mx-auto ">
      <Modal
        open={isOpenModal}
        closable={false}
        onCancel={() => setIsOpenModal(false)}
        footer={null}
        width={580}
        centered
        title={title}
        destroyOnClose
      >
        {modalType === "addByCount" ? (
          <DeviceProductionAddbyCount
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            devicesRefetch={productionRefetch}
            LicenseNo={LicenseNo}
            productionId={productionId}
            itemId={itemId}
          />
        ) : modalType === "addByList" ? (
          <DeviceProductionAddbyList
            isModalForm={true}
            onCancel={() => setIsOpenModal(false)}
            devicesRefetch={productionRefetch}
            LicenseNo={LicenseNo}
            productionId={productionId}
            itemId={itemId}
          />
        ) : null}
      </Modal>
    </div>
  );
};

export default DeviceProductionModal;
